<style type="text/css" scoped>
.menu li i.el-icon-loading {
    width: unset;
    height: unset;
    margin: 5px;
}
.domain-bucket-details {
    position: absolute;
    right: 107px;
    top: 20px;
    cursor: pointer;
}
.domain-bucket-details .text-uppercase {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
}
.domain-bucket-details .clearfix {
    display: inline-block;
    margin-left: 15px;
}
.domain-bucket-details .clearfix:first-child {
    margin-left: 0;
}
.domain-bucket-details > div > div {
    display: inline-block;
}
.domain-bucket-details .atdIcon {
    padding: 0px 5px;
    vertical-align: middle;
}
.upload {
    display: inline-block;
    line-height: 1;
    padding: 7px 8px 7px 3px;
    border-radius: 50%;
    background: #67c23a;
    color: #fff;
    font-size: 15px;
    margin-left: 10px;
}
.relative {
    position: relative;
}
.search-result {
    margin-top: 25px;
    background: #fff;
    /*box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #dadada;*/
    /*width: 375px;*/
    /*left: 0;*/
    font-family: 'Lato';
}
.search-result .search-list .heading {
    font-size: 12px;
    text-transform: uppercase;
    color: #444;
    background: #dadada;
    padding: 5px 10px;
    line-height: 1;
    font-weight: bold;
}

img.round {
    border-radius: 50%;
}
/* New overlay design */
@-webkit-keyframes myFade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.search-overflow {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.98);
    z-index: 9999;
    opacity: 0;
    /*-webkit-transition: opacity 10ms ease-in;
        -moz-transition: opacity 10ms ease-in;
        -o-transition: opacity 10ms ease-in;
        transition: opacity 10ms ease-in;*/
}
.search-overflow.appear {
    opacity: 1;
    /*-webkit-transition: opacity 10ms ease-in;
        -moz-transition: opacity 10ms ease-in;
        -o-transition: opacity 10ms ease-in;
        transition: opacity 10ms ease-in;*/
    overflow-y: scroll !important;
}
.search-overflow .close-container {
    position: absolute;
    right: 20px;
    top: 20px;
    text-align: center;
    cursor: pointer;
}
.search-overflow .cclose {
    text-align: center;
    font-size: 40px;
    background: #717171;
    color: #fff;
    font-weight: 200;
    line-height: 0.3;
    padding: 11px 9px 13px 9px;
    border-radius: 50%;
    display: block;
}
.search-overflow .close-text {
    display: block;
    font-style: italic;
    margin-top: 5px;
    line-height: 1;
    font-size: 13px;
    color: #6d6d6d;
}
.search-container {
    width: 720px;
    margin: auto;
    margin-top: 25px;
}
.search-container .search {
    width: calc(100% - 115px);
    padding-right: 75px;
    position: relative;
}
.search-container .search input {
    width: 100%;
}
.search-container .search:after {
    content: 'or';
    position: absolute;
    right: 9px;
    top: 10px;
}
.search-container .search.searching:before {
    content: '';
    position: absolute;
    top: 13px;
    background: url(/static/img/loader.gif);
    background-repeat: no-repeat;
    width: 17px;
    height: 17px;
    z-index: 1000;
    right: 50px;
}
.search-container .create-button {
    width: 115px;
}
.search-container .create-button a {
    border-radius: 25px;
}
.domain-name {
    display: block;
    line-height: 1;
    font-weight: bold;
    color: #444;
}
.publisher-name {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}
.dfp-name {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 5px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}

.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}
.bucket-list li {
    float: left;
    margin-right: 10px;
}
.bucket-list li:last-child {
    margin-right: 0;
}
.buckets {
    overflow: auto;
}
.notes-box {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 7px 8px 6px 8px;
    border-radius: 50%;
    background-color: white;
}
.notes-box:hover {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 7px 8px 6px 8px;
    border-radius: 50%;
    background-color: white;
}
.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}
.bucket-list li {
    float: left;
    margin-right: 10px;
}
.bucket-list li:last-child {
    margin-right: 0;
}
.buckets {
    overflow: auto;
}
.shadowBox {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
}
.el-badge__content.is-fixed.is-dot {
    right: 15px;
    top: 2px;
    display: none;
}
.header-dropdown-devin {
    top: 10px;
}
.dropdown-menu-devin {
    min-width: 280px;
}
.stories90d .logo-90d {
    width: 65%;
    height: auto !important;
}
.stories90d.main-header .logo {
    height: auto;
    padding: 10px 15px 10px;
}
.stories90d .navbar.navbar-static-top {
    padding-top: 25px;
}
.stories90d .pull-left-search {
    top: 38px;
}
.fa.fa-external-link {
    transition: all 0.5s ease-out;
    visibility: hidden;
    opacity: 0;
}

.notif-message:hover .fa.fa-external-link {
    visibility: visible;
    opacity: 1;
}
</style>
<style type="text/css">
#demo-2 input.devin-search[type='search']:focus {
    width: 20px;
    padding-left: 10px;
    color: transparent;
    cursor: pointer;
}
.search-overflow .el-table__header-wrapper {
    display: none;
}
.pull-left-search {
    cursor: pointer;
}
.Blink {
    display: block;
    animation: blinker 0.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
}

@keyframes blinker {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
</style>
<template>
    <header class="main-header" v-bind:class="{ stories90d: is90d}">
        <router-link to="/admin/domains" class="logo">
            <span v-if="!is90d" class="logo-mini"><b> <img src="/static/img/sm-logo.png" alt="User Image"></b></span>
            <span v-else class="logo-mini"><b> <img src="/static/img/rsz_logo_black_fav.png" alt="User Image"></b></span>
            <span v-show="!is90d" class="logo-lg"><img src="/static/img/bg-logo.png" alt="User Image"></span>
            <span v-show="is90d" class="logo-lg"><img class="logo-90d" src="/static/img/rsz_Logo_Black_Verticle.png" alt="User Image"></span>
            
        </router-link>
        <nav class="navbar navbar-static-top">
            <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </a>
            <div class="pull-left-search" @click="toogleSearch()">
                <form id="demo-2" class="relative">
                    <input class="devin-search" type="search"/>
                </form>
            </div>
            <div class="domain-bucket-details" v-show="domain.name">
                <div class="clearfix">
                    
                    <div class="atdIcon">
                        <svg width="12px" height="12px" aria-hidden="true" data-prefix="fas" data-icon="globe" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-globe fa-w-16 fa-2x"><path fill="currentColor" d="M364.215 192h131.43c5.439 20.419 8.354 41.868 8.354 64s-2.915 43.581-8.354 64h-131.43c5.154-43.049 4.939-86.746 0-128zM185.214 352c10.678 53.68 33.173 112.514 70.125 151.992.221.001.44.008.661.008s.44-.008.661-.008c37.012-39.543 59.467-98.414 70.125-151.992H185.214zm174.13-192h125.385C452.802 84.024 384.128 27.305 300.95 12.075c30.238 43.12 48.821 96.332 58.394 147.925zm-27.35 32H180.006c-5.339 41.914-5.345 86.037 0 128h151.989c5.339-41.915 5.345-86.037-.001-128zM152.656 352H27.271c31.926 75.976 100.6 132.695 183.778 147.925-30.246-43.136-48.823-96.35-58.393-147.925zm206.688 0c-9.575 51.605-28.163 104.814-58.394 147.925 83.178-15.23 151.852-71.949 183.778-147.925H359.344zm-32.558-192c-10.678-53.68-33.174-112.514-70.125-151.992-.221 0-.44-.008-.661-.008s-.44.008-.661.008C218.327 47.551 195.872 106.422 185.214 160h141.572zM16.355 192C10.915 212.419 8 233.868 8 256s2.915 43.581 8.355 64h131.43c-4.939-41.254-5.154-84.951 0-128H16.355zm136.301-32c9.575-51.602 28.161-104.81 58.394-147.925C127.872 27.305 59.198 84.024 27.271 160h125.385z" class=""></path></svg>
                    </div>
                    <div class="name"><router-link :to="'/admin/publisher/'+uuid+'/domain/edit/'+domain.id">{{ domain.name}} </router-link></div>
                   
                </div>
                <div class="clearfix" v-show="bucket.length > 0">
                    
                    <div class="atdIcon">
                        <svg width="12px" height="12px" aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16 fa-2x"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>
                    </div>
                    <div class="name">
                        <el-dropdown @command="bucketChange">
                            <span class="el-dropdown-link">
                                {{ selectedBucketDetails.name }} <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :key="b.id" v-for="b in bucket" :command="`${ b.id }`">{{ b.name }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <a href="javascript:void(0);" class="upload" @click="createJs()">
                            <i class="el-icon-upload el-icon--right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="navbar-custom-menu">
                <ul class="nav navbar-nav">
                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click" @visible-change="notifDropdownToggle">
                            <span class="el-dropdown-link">
                                <el-badge class="item">
                                    <el-button type="text" size="small"><i class="ti-bell"></i></el-button>
                                </el-badge>
                                <sup class="el-badge__content is-fixed is-dot Blink" ref="notifDot"></sup>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <ul class="dropdown-menu-devin">
                                    <li class="header">Latest notifications</li>
                                    <li>
                                        
                                        <ul class="menu">
                                            
                                            <h5 v-if="allNotifications.length == 0" style="text-align: center;color: #d75252;">No new notifications</h5>
                                            
                                            <li v-for="notif in allNotifications" :key="notif.id"> <i class="ti-user"></i>
                                                <a href="#">
                                                    <div v-if="notif.pub_uid && notif.domain_id">
                                                        <router-link :to="{ path: `/admin/publisher/${notif.pub_uid}/domain/edit/${notif.domain_id}/` }">
                                                            <h3 class="notif-message">{{ notif.message }}<span class="text-yellow fontello-record">
                                                                
                                                                <i v-if="notif.type=='started'" class="el-icon-loading"></i>

                                                                <i v-if="notif.type=='complete'" class="el-icon-success"></i>

                                                                <i v-if="notif.type=='error'" class="el-icon-error" style="color: red !important;"></i>
                                                                <i class="fa fa-external-link" aria-hidden="true"></i>
                                                            </span>
                                                                </h3>
                                                        </router-link>
                                                    </div>

                                                    <div v-else>
                                                        <h3 class="notif-message">{{ notif.message }}<span class="text-yellow fontello-record">
                                                            
                                                            <i v-if="notif.type=='started'" class="el-icon-loading"></i>

                                                            <i v-if="notif.type=='complete'" class="el-icon-success"></i>

                                                            <i v-if="notif.type=='error'" class="el-icon-error" style="color: red !important;"></i>
                                                        </span>
                                                            </h3>
                                                    </div>
                                                    <p>at {{notif.timestamp | moment("'MMM Do YYYY, h:mm:ss a")}}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    
                                </ul>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li>
                        <el-dropdown class="header-dropdown-devin" trigger="click"> <span class="el-dropdown-link"><el-button data-toggle="control-sidebar" type="text" size="small"><i class="ti-menu-alt"></i></el-button></span>
                        </el-dropdown>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="search-overflow" v-bind:class="{appear:search.showSearch}" v-show="search.showSearch">
            <div class="close-container" @click="toogleSearch()">
                <span class="cclose">&times;</span>
                <span class="close-text">Esc</span>
            </div>
            <div class="search-container">
                <div class="clearfix">
                    <div class="search pull-left" v-bind:class="{searching:search.networkcall}" >
                        <input ref="search" class="devin-search" type="search" v-model="search.query" placeholder="Search..." @keyup="searchDomPub"/></input>
                    </div>
                    <div class="create-button pull-left">
                        <router-link :to="{ path: `/admin/create-domain/` }">
                            <a href="javascript:void(0);" @click="redirect('/admin/create-domain/')" class="el-button el-button--success">
                                <i class="el-icon-plus el-icon-left"></i>
                                Domain
                            </a>
                        </router-link>
                    </div>
                </div>
                <div class="search-result">
                    <div class="search-list">
                        <div class="heading">Domain list</div>
                        <el-table :data="search.domains" style="width: 100%;border-spacing: 0;" v-loading="loading">
                            <el-table-column label="" width="50">
                                <template slot-scope="scope">
                                    <div class="text-center">
                                        <img class="round" width="30" height="30" :avatar="`${scope.row.name}`">
                                        
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="300" label="" prop="name">
                                <template slot-scope="props">
                                    <router-link :to="{ path: `/admin/publisher/${props.row.publisher.uuid}/domain/edit/${props.row.id}/` }">
                                        <a href="javascript:void(0);" @click="redirect('/admin/publisher/'+ props.row.publisher.uuid +'/domain/edit/'+ props.row.id +'/')">
                                            <span class="domain-name">{{`${props.row.name}`}}</span>
                                            <span class = "publisher-name">{{`${props.row.publisher.name}`}}</span>
                                            <span v-if="props.row.dfp_network!=null" class = "dfp-name">{{`${props.row.dfp_network.display_name}`}} DFP</span>
                                        </a>
                                    </router-link>
                                </template>
                            </el-table-column>
                             <el-table-column label="Reports" prop="Reports" width="50">
                                <template slot-scope="props">
							
                                        <el-tooltip content="Reports" placement="bottom">
                                            
                                             <router-link :to="{ path: `/admin/publisher/${props.row.publisher.id}/ReportsRevenue/${props.row.id}/` }">
                                                 <a href="javascript:void(0);" @click="redirect('/admin/publisher/'+props.row.publisher.id+'/ReportsRevenue/' + props.row.id)">
                                                            <el-button class = "notes-box" type="text" size="small">
                                                            <span>
                                                                 <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            </span>
                                                        </el-button>
                                                 </a>
                                             </router-link>
                                     </el-tooltip>
                                    </template>
                            </el-table-column>
                            <el-table-column width="50">
                                <template slot-scope="props">
                                    <el-dropdown class="" trigger="click">
                                        <span class="el-dropdown-link">
                                            <el-badge :value="0" :max="10" class="item">
                                                <el-button class = "notes-box" type="text" size="small" v-clipboard:copy="props.row.site_tag" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                                    <span>
                                                    <svg width="17px" height="17px" aria-hidden="true" data-prefix="fal" data-icon="copy" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-copy fa-w-14 fa-2x"><path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z" class=""></path></svg>
                                                </span> 
                                                </el-button>
                                            </el-badge>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <ul class="dropdown-menu-devin" style="max-width: 700px !important;">
                                                <li class="header" style="margin:5px; padding 0px; font-size: 12px;">
                                                    {{(props.row.site_tag) ? props.row.site_tag : 'No Script Present.'}}
                                                </li>
                                                <li class="text-danger" style="margin-left:20px; padding 0px; font-size: 10px;">
                                                    <b>copied!</b>
                                                </li>
                                            </ul>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                            <el-table-column width="50">
                                <template slot-scope="props">
                                    <router-link :to="{ path: `/admin/domains/notes/${props.row.id}` }">
                                        <a href="javascript:void(0);" @click="redirect('/admin/domains/notes/'+ props.row.id)">
                                            <el-button class = "notes-box" type="text" size="small">
                                                <span>
                                                    <svg width="17px" height="17px" aria-hidden="true" data-prefix="far" data-icon="pen-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-pen-square fa-w-14 fa-2x"><path fill="currentColor" d="M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" class=""></path></svg>
                                                </span>
                                            </el-button>
                                        </a>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="props">
                                    <div class="buckets">
                                        <ul class="bucket-list clearfix" v-bind:style="{width: (122 * ((props.row.buckets && props.row.buckets.length) > 3 ? props.row.buckets.length : 4)) +'px'}">
                                            <li v-for="bucket in props.row.buckets" class ="shadowBox">
                                                <router-link :to="{ path: `/admin/publisher/${props.row.publisher.uuid}/domain/${props.row.id}/buckets/${bucket.id}/` }">
                                                    <a href="javascript:void(0);" @click="redirect('/admin/publisher/'+ props.row.publisher.uuid +'/domain/'+ props.row.id +'/buckets/'+ bucket.id +'/')">
                                                        <span class = "">
                                                            <svg aria-hidden="true" width="12" height="12" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16 fa-3x">
                                                                <path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path>
                                                            </svg>
                                                        </span>
                                                        <span class=""> {{`${bucket.name}`}}</span>
                                                    </a>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import axios from 'axios';
import LetterAvatar from '../../../static/plugins/letterAvatar.js';
let setdata = function (params, path) {
        if (path) for (let key in params) path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);

        return path;
    },
    getTopBarNav = (controllerName, params, callback) => {
        console.log('Controller Name');
        console.log(controllerName);
        console.log(params);
        switch (controllerName) {
            case 'DomainContext':
            case 'DomainBucket':
            case 'DomainContext':
            case 'BlockCategories':
            case 'BlockURLS':
            case 'EditDomain':
            case 'FiSetupAdSpots':
            case 'Layout':    
            case 'HbTagParams':
            case 'ModifyHbTag':
            case 'HbTagParamSet':
            case 'HbTagParamsAMP':
            case 'CreateHbTag':
            case 'CreateHbTagAmp':
            case 'Manage Services':
            case 'ads.txt':
            case 'KeywordBlock':  
            case 'Manage Stories':
            case 'Create Manage Service Tag':
                let path = 'v1/publishers/{uuid}/domains/{domId}/';
                path = setdata(params, path);
                axios.get(BASE_URL + path).then((response) => {
                    callback({
                        selectedBucketDetails: {},
                        domain: {
                            id: response.data.id,
                            name: response.data.name,
                            domuuid: response.data.uuid,
                        },
                        bucket: [],
                        currentBucket: undefined,
                    });
                });
                break;

            case 'BucketDetails':
            case 'CreateDirectCampaign':
            case 'AllDirectCampaign':
            case 'FirstImpression':
            case 'BucketSettings':
            case 'AxtModule':
            case 'StickyModule':
            // case 'CreateHbTag':
            // case 'ModifyHbTag':
            // case 'HbTagParams':
            // case 'HbTagParamsAMP':
            case 'CreateHbTag':
            case 'CreateHbTagAmp':
            case 'FiTagAssociation':
            case 'Header-Bidding-Tags':
                let domPath = 'v1/publishers/{uuid}/domains/{domId}/';
                domPath = setdata(params, domPath);

                axios.get(BASE_URL + domPath).then((response) => {
                    let selectedBucketDetails = {};
                    for (let i = 0; i < response.data.buckets.length; i++)
                        if (response.data.buckets[i].id == params.bucketId)
                            selectedBucketDetails = response.data.buckets[i];
                    callback({
                        selectedBucketDetails: selectedBucketDetails,
                        domain: {
                            id: response.data.id,
                            name: response.data.name,
                            domuuid: response.data.uuid,
                        },
                        bucket: response.data.buckets,
                        currentBucket: params.bucketId,
                    });
                });
                break;
            case 'ReportsRevenue':
                console.log('this.$route.params.pubid');
                console.log(8);
                // this.domain = { name: "" };
                // callback({
                //     selectedBucketDetails: {},
                //     domain: {
                //         id: 23,
                //         name: "lll",
                //         domuuid: "ld,d",
                //     },
                //     bucket: [],
                //     currentBucket: undefined,
                // });

                axios
                    .post(BASE_URL + 'reports/v1/pub-get-dash-info/', {
                        publisherId: params.pubid,
                    })
                    .then((response) => {
                        if (response.data.status) {
                            let domain = response.data.data.find((k) => {
                                return params.domid == k.domain_id;
                            });
                            console.log(response.data);
                            // console.log(this.$route.params.domid);
                            // this.domain.name = "lll";
                            callback({
                                selectedBucketDetails: {},
                                domain: {
                                    id: domain.domain_id,
                                    name: domain.domain_name,
                                },
                                bucket: [],
                                currentBucket: undefined,
                            });

                            // return this.allDomains;
                        }
                    })
                    .catch((e) => {
                        //console.log(e);
                    });
                break;
            default:
                callback({
                    selectedBucketDetails: {},
                    currentBucket: undefined,
                    domain: {},
                    bucket: [],
                });
                break;
        }
    },
    bindEvent = (el, event, fn) => {
        el.addEventListener
            ? el.addEventListener(event, fn, false)
            : el.attachEvent && el.attachEvent('on' + event, fn);
    },
    unbindEvent = (el, event, fn) => {
        el.removeEventListener ? el.removeEventListener(event, fn) : el.detachEvent && el.detachEvent('on' + event, fn);
    };
import { EventBus } from '../../event-bus.js';
import PusherJS from 'pusher-js';

export default {
    name: 'DashboardHeader',
    data() {
        return {
            selectedBucketDetails: {},
            currentBucket: undefined,
            isDirty: false,
            dropDownOpen: false,
            domain: {},
            bucket: [],
            uuid: this.$route.params.uuid,
            search: {
                binded: false,
                showSearch: false,
                networkcall: false,
                showres: false,
                timer: undefined,
                query: undefined,
                domains: [],
            },
            allNotifications: [],
            // is90d: false
        };
    },
    props: {
        domain_details: Object,
        is90d: Boolean,
    },
    mounted: function () {
        console.log('this.$route.name');
        console.log(this.$route.name);
        getTopBarNav(this.$route.name, this.$route.params, (topbar) => {
            this.currentBucket = topbar.currentBucket;
            this.bucket = topbar.bucket;
            this.domain = topbar.domain;
            this.selectedBucketDetails = topbar.selectedBucketDetails;
        });
    },
    created: function () {
        console.log(this.domain_details);
        var pusher = new PusherJS(...JSON.parse(PUSHER_CREDENTIALS.replace('AUTH_TOKEN_HERE', localStorage.getItem('default_auth_token'))))

        console.log(pusher);
        var channel = pusher.subscribe('private-test');
        console.log(channel);
        let self = this;
        channel.bind('my-event', (data) => {
            console.log("PUSHER DATA", data);
            if (data.type == 'complete') {
                EventBus.$emit('update_logs', {});
            }

            let existing = self.allNotifications.filter((notif) => {
                return notif.id == data.id;
            });
            if (existing[0]) {
                existing[0].type = data.type;
                existing[0].message = data.message;
                existing[0].timestamp = data.timestamp;
                console.log(self.allNotifications);
            } else {
                self.allNotifications.push(data);
                console.log(self.allNotifications);
            }
            if (!this.dropDownOpen) self.$refs.notifDot.style.display = 'block';
        });

        // if(this.$route.path.indexOf('stories/') > -1 || this.$route.path.indexOf('manage-service/') > -1 || this.$route.path.indexOf('manage-story/') > -1) this.is90d = true
    },
    methods: {
        createJs() {
            axios
                .post(BASE_URL + 'v1/cdn_push/', {
                    bucketId: this.$route.params.bucketId,
                })
                .then((response) => {
                    var type = 'Error',
                        message = 'Oops Something went wrong!';
                    if (response.data.response_data.status) {
                        type = 'Success';
                        message = response.data.response_data.message;
                    } else {
                        type = 'Error';
                        message = response.data.response_data.message;
                    }
                    this.$notify({
                        title: type,
                        message: message,
                        type: type.toLowerCase(),
                    });
                });
        },
        bucketChange(command) {
            setTimeout(() => {
                this.$router.push(
                    '/admin/publisher/' +
                        this.$route.params.uuid +
                        '/domain/' +
                        this.$route.params.domId +
                        '/buckets/' +
                        command
                );
            });
        },
        toogleSearch() {
            let _this = this,
                keyUpBind = (e) => {
                    if (e.keyCode == 27 && _this.search.binded) {
                        _this.search.showSearch = !_this.search.showSearch;
                        unbindEvent(document, 'keyup', keyUpBind);
                        _this.search.binded = false;
                    }
                };

            this.search.showSearch = !this.search.showSearch;
            // this.$refs.search.$el.focus();
            // this.$refs.search.$refs.input.focus();
            // console.log(this.$refs.search.$refs.input);
            if (this.search.showSearch && !this.search.binded) {
                bindEvent(document, 'keyup', keyUpBind);
                jQuery('.search-overflow').fadeIn(10);
                jQuery('.search-overflow input').focus();
                this.search.binded = true;
            } else if (this.search.binded) {
                unbindEvent(document, 'keyup', keyUpBind);
                this.search.binded = false;
            }
        },
        redirect(path) {
            this.toogleSearch();
            // window.location.replace(path);
            // this.$router.push(path);
        },
        searchDomPub() {
            window.clearTimeout(this.search.timer);
            this.search.timer = setTimeout(() => {
                this.search.networkcall = true;
                axios.get(BASE_URL + 'v1/search/?query=' + this.search.query).then((response) => {
                    this.search.networkcall = false;
                    this.search.domains = response.data.results;
                    this.search.showres = true;
                    window.setTimeout(function () {
                        LetterAvatar.transform();
                    });
                });
            }, 500);
        },
        notifDropdownToggle(evt) {
            // console.log(evt);
            // console.log(this.$refs.notifDot);
            // this.$refs.notifDot.classList.toggle('Blink');
            this.dropDownOpen = !this.dropDownOpen;
            if (evt) this.$refs.notifDot.style.display = 'none';
            if (!evt) {
                window.setTimeout(() => {
                    this.allNotifications = this.allNotifications.filter((notif) => {
                        return !(notif.type == 'complete');
                    });
                }, 1000);
            }
        },
    },
    watch: {
        $route: function (newUrl, oldUrl) {
            // if(newUrl.path.indexOf('stories/') > -1 || newUrl.path.indexOf('manage-service/') > -1 || newUrl.path.indexOf('manage-story/') > -1) this.is90d = true
            // else this.is90d = false;
            console.log(this.is90d);
            if(newUrl.path !== oldUrl.path){
                getTopBarNav(newUrl.name, newUrl.params, (topbar) => {
                    this.currentBucket = topbar.currentBucket;
                    this.bucket = topbar.bucket;
                    this.domain = topbar.domain;
                    this.selectedBucketDetails = topbar.selectedBucketDetails;
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Header.vue?fbe7814e